import Model from "@/models/Model"

export default class Role extends Model {

    selected_permissions = []

    static includes = [
        "permissions",
    ]

    mapPermission ( item ) {
        return item.id
    }

    reset () {

        //
        this.selected_permissions = this.permissions

        //
        return this
    }

    resource() {
        return "roles"
    }

    toCreate () {

        //
        this.permissions = this.selected_permissions.map( this.mapPermission )

        //
        return this.clean([
            "name",
            "permissions",
            "role_name",
        ])
    }
    
    toUpdate () {

        //
        this.permissions = this.selected_permissions.map( this.mapPermission )

        //
        return this.clean([
            "id",
            "name",
            "permissions",
            "role_name",
        ])
    }
}